import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api objects
export const getListObjects = (
    page_number = 1,
    page_size = 10,
    status = 0,
    textSearch = '',
    begin_time = 0,
    end_time = 0,
    type_search = ''
) => {
    if (textSearch === '' && begin_time == 0 && end_time == 0 && type_search == '')
        return api.makeAuthRequest({
            url: `/object?page_number=${page_number}&page_size=${page_size}&deleted=${status}`,
            method: 'GET',
        })

    // return api.makeAuthRequest({
    //     url: `/search/objects?page_number=${page_number}&page_size=${page_size}&status=${status}&text=${textSearch}`,
    //     method: 'GET',
    // })
    return api.makeAuthRequest({
        url: `/search/objects_v2`,
        method: 'POST',
        data: {
            "type_search": type_search,
            "text_search": textSearch,
            "page_number": page_number,
            "page_size": page_size,
            "status": status,
            "begin_time": begin_time,
            "end_time": end_time

        }
    })
}
export const getListObjectsByName = (
    page_number = 1,
    page_size = 10,
    status = 0,
    textSearch = ''
) => {


    return api.makeAuthRequest({
        url: `/search/objects/name?page_number=${page_number}&page_size=${page_size}&status=${status}&text=${textSearch}`,
        method: 'GET',
    })
}

export const createObject = object => {
    const json = JSON.stringify(object)

    return api.makeAuthRequest({
        url: `/object`,
        method: 'POST',
        data: json,
        header: {
            'Content-Type': 'application/json',
        },
    })
}

export const getObjectById = oid => {
    return api.makeAuthRequest({
        url: `/object/${oid}`,
        method: 'GET',
    })
}

export const updateObjectById = (oid, object) => {
    const json = JSON.stringify(object)

    return api.makeAuthRequest({
        url: `/object/${oid}`,
        method: 'PUT',
        data: json,
        header: {
            'Content-Type': 'application/json',
        },
    })
}

export const deleteObject = oid => {
    return api.makeAuthRequest({
        url: `/object/${oid}`,
        method: 'DELETE',
    })
}
export const getListObjectQuerybyid = lst => {
    return api.makeAuthRequest({
        url: `/object/query/list?ids=${lst}`,
        method: 'GET',
    })
}

export const getListDataRelate = oid => {
    return api.makeAuthRequest({
        url: `/object/${oid}/ext`,
        method: 'GET',
    })
}
